import React, { FC, useEffect } from 'react';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../../components/table/Table';

import { formattedProviderData } from '../../store/tables/admin/provider-data';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { usePaymentContext } from '../../store/payments/payments-context';
import {
  exportCSVProviderData,
  setProvidersToDefault,
} from '../../store/payments/actions/providers';
import { ExportCSVButton } from '../../components/form/ExportCSVButton';

interface Props {
	listener?: (search: any) => Promise<void>;
}

export const Provider: FC<Props> = (props) => {
	const { listener } = props;

	const { merchantState: { isListOfMerchantsLoading, isPartnerNamesListLoading }} = useMerchants();

	const { paymentContextState, dispatch } = usePaymentContext();
	const { providerData, isProviderDataLoading, isExportProviderCSVLoading } = paymentContextState;


  useEffect(() => {
    return () => {
      setProvidersToDefault(dispatch);
    };
  }, []);

	return (
		<>
			<Table
				name={TablesNames.providerTableData}
				data={formattedProviderData(providerData) ?? []}
				isLoading={isProviderDataLoading || isListOfMerchantsLoading || isPartnerNamesListLoading}
				toolbarCustomAction={
					<ExportCSVButton
						orderTotalItemCount={formattedProviderData(providerData).length}
						isExportCSVLoading={isExportProviderCSVLoading}
						exportCSV={async (): Promise<void> => await exportCSVProviderData({ dispatch, state: paymentContextState })}
					/>
				}
				queryParamsListener={listener}
			/>
		</>
	);
};
